// extracted by mini-css-extract-plugin
module.exports = {"optionTiles":"styles_optionTiles__RLz75"};